import React from 'react';
import { Search, Menu } from 'lucide-react';
export function Masthead() {
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return <header className="w-full bg-paper pt-4 pb-2 px-4 md:px-8 border-b-4 border-double border-ink mb-2" data-id="element-21">
      {/* Top utility bar */}
      <div className="flex justify-between items-center border-b border-gray-300 pb-2 mb-4 text-xs md:text-sm font-serif text-gray-600" data-id="element-22">
        <div className="flex items-center gap-4" data-id="element-23">
          <button className="md:hidden" data-id="element-24">
            <Menu className="w-5 h-5 text-ink" data-id="element-25" />
          </button>
          <span className="hidden md:inline" data-id="element-26">{today}</span>
          <span className="hidden md:inline text-gray-300" data-id="element-27">|</span>
          <span className="hidden md:inline" data-id="element-28">Vol. CXLV No. 24,301</span>
        </div>
        <div className="flex items-center gap-4" data-id="element-29">
          <span className="hidden md:flex items-center gap-2" data-id="element-30">
            <span className="font-bold text-ink" data-id="element-31">London</span>
            <span className="font-body italic" data-id="element-32">12°C Cloudy</span>
          </span>
          <span className="text-gray-300" data-id="element-33">|</span>
          <button className="flex items-center gap-1 hover:text-ink transition-colors" data-id="element-34">
            <Search className="w-4 h-4" data-id="element-35" />
            <span className="hidden sm:inline" data-id="element-36">Search</span>
          </button>
          <button className="bg-ink text-paper px-3 py-1 text-xs uppercase tracking-widest font-bold hover:bg-accent transition-colors" data-id="element-37">
            Subscribe
          </button>
        </div>
      </div>

      {/* Main Title */}
      <div className="text-center py-4 md:py-8 relative" data-id="element-38">
        <div className="absolute top-1/2 left-0 w-full h-px bg-ink opacity-20 -z-10 hidden md:block" data-id="element-39"></div>
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black font-serif tracking-tight text-ink leading-none inline-block bg-paper px-8" data-id="element-40">
          LexisVox
        </h1>
        <div className="mt-4 flex justify-center items-center gap-4 text-xs font-bold uppercase tracking-[0.2em] text-gray-500" data-id="element-41">
          <span className="w-12 h-px bg-gray-400" data-id="element-42"></span>
          <span data-id="element-43">Est. 1886</span>
          <span className="w-12 h-px bg-gray-400" data-id="element-44"></span>
        </div>
      </div>
    </header>;
}